import custom from './custom';
import promoteJobs from './promoteJobs';
import promoteContentShares from './promoteContentShares';
import scheduleJobs from './scheduleJobs';
import scheduleContentShares from './scheduleContentShares';
import invite from './invite';
import leaderboardIndividual from './leaderboardIndividual';
import leaderboardOverall from './leaderboardOverall';
import collectiveGoal from './collectiveGoal';
import gamificationUpdateIndividual from './gamificationUpdateIndividual';
import promoteJob from './promoteJob';
import promoteContent from './promoteContent';

export default [
  custom,
  invite,
  leaderboardIndividual,
  leaderboardOverall,
  collectiveGoal,
  gamificationUpdateIndividual,
  promoteJob,
  promoteJobs,
  promoteContent,
  promoteContentShares,
  scheduleJobs,
  scheduleContentShares
];


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/index.js